import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useWebPush } from '@/hooks/useWebPush';
import { Button } from '@/components/ui/button';
import { BellRing, X } from 'lucide-react';

export const WebPushPrompt = () => {
  const { hasRole } = useAuth();
  const { isSupported, permission, isSubscribed, loading, requestPermissionAndSubscribe } = useWebPush();
  const [dismissed, setDismissed] = useState(false);

  // Somente exibir para usuários do perfil provas
  const isPerfilProvas = hasRole('provas');

  // Não exibir se não suportado, já inscrito, permissão negada, ou dispensado
  if (!isSupported || isSubscribed || permission === 'denied' || dismissed || !isPerfilProvas) {
    return null;
  }

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-3 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center flex-1 gap-3 min-w-0">
          <span className="flex p-2 rounded-lg bg-primary/20">
            <BellRing className="h-5 w-5 text-primary" aria-hidden="true" />
          </span>
          <p className="font-medium text-sm truncate">
            <span className="md:hidden">Ative as notificações de provas!</span>
            <span className="hidden md:inline">
              Receba um alerta imediato quando uma nova prova for solicitada para impressão.
            </span>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            onClick={requestPermissionAndSubscribe}
            disabled={loading}
            size="sm"
            className="w-full sm:w-auto"
          >
            {loading ? 'Ativando...' : 'Ativar Notificações'}
          </Button>
          <Button
            onClick={() => setDismissed(true)}
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-muted-foreground hover:bg-muted"
          >
            <span className="sr-only">Dispensar</span>
            <X className="h-4 w-4" aria-hidden="true" />
          </Button>
        </div>
      </div>
    </div>
  );
};
